<template>
  <div class="header-right">
    <a-input class="search" ref="searchInput" v-model="searchText" placeholder="搜索课程" @blur="onSearchTextChange">
      <a-icon slot="prefix" type="search" />
    </a-input>
    <a-button class="history" type="link" icon="history" @click="goTo('/playbackRecord')">
      历史记录
    </a-button>
    <a-button type="link" class="note" @click="goTo('/message')">
      <a-badge :dot="hasNewMessage">
        <span slot="count" class="custom-badge" v-if="hasNewMessage">新消息</span>
        <a-icon type="bell" theme="filled"/>
      </a-badge>
      <span class="note-title" v-if="!hasNewMessage">消息</span>
    </a-button>
    <a-avatar class="login-avatar" :src="userInfo.avatar || require('../../assets/images/common/avatar.png')"></a-avatar>
    <a-dropdown>
      <a class="login-name ant-dropdown-link" @click="e => e.preventDefault()">{{userNick}}<a-icon type="down" />
      </a>
      <a-menu slot="overlay">
        <a-menu-item key="3" @click="exit">
          退出
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import certificateManagement from '@/api/certificate-management'
import eventHub from '@/event-hub'
import { message } from '@/api'

export default {
  name: 'HeaderRight',
  data () {
    return {
      userInfo: {
        userName: '青浦实验小学四（1）班',
        avatar: '',
        nick: ''
      },
      hasNewMessage: false,
      searchText: ''
    }
  },
  computed: {
    userNick() {
      let { nick, userName } = this.userInfo
      if (nick === undefined || nick === '' || nick === null) {
        return userName
      }
      return nick
    }
  },
  beforeDestroy () {
    eventHub.$off('updateMessageStatus', this.onUpdateMesssageStatus)
  },
  mounted () {
    this.userInfo = certificateManagement._readUserInfo() || {}
    this.onUpdateMesssageStatus = this.onUpdateMesssageStatus.bind(this)
    eventHub.$on('updateMessageStatus', this.onUpdateMesssageStatus)
    this.getMessageStatus()
  },
  methods: {
    onUpdateMesssageStatus (status) {
      this.hasNewMessage = status
    },
    onSearchTextChange () {
      eventHub.$emit('searchCourse', {text: this.searchText})
      this.$router.push({name: 'searchResult', params: {text: this.searchText}})
    },
    goTo (path) {
      this.$router.push(path)
    },
    exit () {
      certificateManagement.logout()
      this.$router.push('/login')
    },
    getMessageStatus () {
      let temp = {
        page: 1,
        pageSize: 10,
        type: 2
      }
      return message.messageList(temp).then(res => {
        let { data, status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }
        let { total = 0 } = data || {};
        this.hasNewMessage = total > 0
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .header-right{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .login-name{
      font-size: 12px;
      color: #fff;
      .anticon{
        color: #fff;
        margin-left: 9px;
      }
    }
    .login-avatar{
      width: 32px;
      height: 32px;
      margin-right: 9px;
    }
    .note {
      color:#A0A097;
      margin-right: 37px;
      padding: 0 11px 0 11px;
      .anticon{
        font-size: 16px;
      }
      
      &-title{
        margin-left: 2px;
        font-size: 12px;
      }
      .custom-badge{
        font-size: 9px;
        color: #fff;
        background-color: #FF0000;
        border-radius: 12px;
        line-height: 1;
        right: -12px;
        top: 4px;
		padding: 2px 5px 5px 5px;
		
      }
    }
    .history{
      padding: 0 11px;
      color:#A0A097;
    }
    .search{
      width: 330px;
      margin-right: 60px;
      .anticon{
        color: #FFFFFF;
      }
    }
  }
</style>

<style lang="less">
.header-right{
  .note{
    .ant-badge-dot{
      width: 5px;
      height: 5px;
      box-shadow: none;
    }
  }
  
  .search{
    .ant-input{
      background: #676767;
      border: none;
      color: #B9B9B9;
      border-radius: 40px;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
    }
  }
}
  
</style>